<template>
  <div class="control__elements">
    <div class="field-qr-code">
      <QRCodeCanvas :value="resolvedSourceValue" :size="120" />
      <p v-if="sourceFieldName" class="field-qr-code__source-note">
        {{ $t('rowEditFieldQRCode.sourceNote', { name: sourceFieldName }) }}
      </p>
    </div>
  </div>
</template>

<script>
import rowEditField from '@baserow/modules/database/mixins/rowEditField'
import sourceFieldReferenceField from '@baserow/modules/database/mixins/sourceFieldReferenceField'
import QRCodeCanvas from '@baserow/modules/database/components/field/QRCodeCanvas'

export default {
  name: 'RowEditFieldQRCode',
  components: { QRCodeCanvas },
  mixins: [rowEditField, sourceFieldReferenceField],
  computed: {
    sourceFieldName() {
      const fields =
        this.allFieldsInTable?.length > 0
          ? this.allFieldsInTable
          : this.$store.getters['field/getAll']
      return fields.find((f) => f.id === this.field.source_field_id)?.name
    },
  },
}
</script>
